import React, {useState, useEffect} from 'react';
import { Link, useParams } from 'react-router-dom';
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import parse from 'html-react-parser';
import axios from 'axios';
import { API_URL } from '../global/components/Constants';
import { saveApplicant } from '../utils/api-services/job';
import PageLoader from '../global/components/PageLoader';
import { icon } from '@fortawesome/fontawesome-svg-core';

function JobPostDetails() {

    const [job, setJob] = useState(null);
    const [hasApplied, setHasApplied] = useState(false);
    const [loading, setLoading] = useState(false);
    const [posting, setPosting] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [width, setWidth] = useState(window.innerWidth);
    
    const session = localStorage.getItem("session");
    const isMobile = width <= 768;
    const { code } = useParams();
    

    useEffect(()=>{
        loadJobPost();
    }, []);

    function loadJobPost(){
        setLoading(true);
        axios({
            method: 'get',
            url: API_URL + `job/job_post_by_slug?slug=${code}`,
        }).then((respose)=>{
            const obj = respose.data;
            if(obj.Success){
                setJob(obj.Data);
                setLoading(false);
            }
        });
    }

    const postApplicant = async () => {
        setPosting(true);
        const res = await saveApplicant(job?.Slug, "");
        if(res.Success){
            setHasApplied(true);
        }else{
            setErrorMsg("Failed to post application");
        }
        setPosting(false);
    }

    const styles = {
        page:{
            background: '#fff',
            minHeight: 700,
            paddingTop: 50,
            paddingBottom: 100
        },
        brand:{
            wrap:{
                display: 'flex',
                marginBottom: 20,
            },
            logo:{
                wrap:{
    
                },
                img: {
    
                },
                placeholder:{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: '#f6f9f7',
                    width: 80,
                    height: 80,
                    marginRight: 15,
                    border: '1px solid #009900',
                    borderRadius: 10,
                },
                text:{
                    flex: 1,
                    color: '#009900',
                    fontSize: 60,
                    fontWeight: 700,
                    textAlign: 'center',
                    lineHeight: 0
                }
            },
            content:{
                wrap:{
    
                },
                title: {
                    color: '#363636',
                    marginBottom: 2,
                    fontSize: 20,
                    fontWeight: 500
                },
                label: {
                    color: '#363636',
                    fontSize: 15
                }
            },
        },
        feature:{
            wrap:{
                padding: '20px 0px'
            },
            title:{
                color: '#333',
                marginBottom:15,
                fontSize: 16,
                fontWeight: 600
            },
            items:{
                display: 'flex',
                flexWrap: 'wrap'
            },
            item: {
                background: '#f8f5fe',
                color: '#717886',
                marginTop: 5,
                marginRight: 10,
                marginBottom: 5,
                padding: '2px 10px',
                borderRadius: 3,
                fontSize: 15,
            }
        },
        section:{
            wrap:{
                padding: '20px 0px'
            },
            title:{
                color: '#333',
                marginBottom: 5,
                fontSize: 16,
                fontWeight: 600
            },
            value: {
                color: '#363636',
                fontSize: 16,
            }
        },
        apply:{
            desktop:{
                background: '#fff',
                padding: 10,
                border: '1px solid #ccc',
                borderRadius: 5,
            },
            mobile:{
                background: '#fff',
                padding: 20,
                borderTop: '1px solid #ccc',
                position: 'fixed',
                left: 0,
                right: 0,
                bottom: 0
            },
            title:{
                color: '#333',
                marginBottom: 3,
                fontSize: 18,
                fontWeight: 600
            },
            info:{
                marginBottom: 30,
                fontSize: 14
            },
            btn:{
                width: '100%',
                boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
            }
        },
        success:{
            desktop:{
                background: '#fff',
                padding: 10,
                border: '1px solid #ccc',
                borderRadius: 5,
                textAlign: 'center'
            },
            mobile:{
                background: '#fff',
                padding: 20,
                borderTop: '1px solid #ccc',
                position: 'fixed',
                left: 0,
                right: 0,
                bottom: 0,
                textAlign: 'center'
            },
            icon:{
                color: '#009900',
                marginBottom: 10,
                fontSize: 30
            },
            title:{
                color: '#333',
                marginBottom: 3,
                fontSize: 18,
                fontWeight: 600
            },
            info:{
                color: '#333',
                marginBottom: 20,
                fontSize: 14
            },
            btn:{
                background: '#fff',
                color: '#000099',
                width: '100%',
            }
        },
        errorMsg:{
            color: '#990000',
            marginBottom: 20,
            fontSize: 16,
        }
    }

    function holderLogo(name){
        return name.charAt(0).toUpperCase();
    }

    const applyWithSession = (
        <div style={isMobile? styles.apply.mobile: styles.apply.desktop}>

            {!isMobile &&
                <div>
                    <div style={styles.apply.title}>Job Applicant</div>
                    <div style={styles.apply.info}>After applying, it is advisable to update your CV for employer to see your current work status.</div>
                </div>
            }

            {(errorMsg != "") && <div style={styles.errorMsg}>{errorMsg}</div>}

            <Link 
                onClick={postApplicant} 
                style={styles.apply.btn}
                className='btn btn-primary'
                disabled={posting? true: false}
            >
                {posting? "Posting ...": "APPLY"}
            </Link>
        </div>
    )

    const applyWithNoSession = (
        <div style={isMobile? styles.apply.mobile: styles.apply.desktop}>

            {!isMobile &&
                <div>
                    <div style={styles.apply.title}>Job Applicant</div>
                    <div style={styles.apply.info}>After applying, it is advisable to update your CV for employer to see your current work status.</div>
                </div>
            }

            <Link 
                to={`/user/sign-in/job-application?code=${job?.Slug}`} 
                style={styles.apply.btn}
                className='btn btn-primary'
            >
                APPLY HERE
            </Link>
        </div>
    )

    function applySuccess(){
        return (
            <div style={isMobile? styles.success.mobile: styles.success.desktop}>
                <FontAwesomeIcon icon={faCheckCircle} style={styles.success.icon} />
                <div style={styles.success.title}>Application Completed</div>
                <div style={styles.success.info}>Thanks for applying, we will get back to you.</div>
                <Link 
                    to={`/cv/me`} 
                    style={styles.success.btn}
                    className='btn btn-sm btn-primary'
                >
                    UPDATE YOUR CV
                </Link>
            </div>
        )
    }

    function displayApply(){
        if(hasApplied){
            return applySuccess();
        }else{
            return session? applyWithSession: applyWithNoSession
        }
    }

    const display = (
        <section style={styles.page}>
        {job &&
            <div className='container'>
                <div className='row'>
                        
                    <div className='col-md-8'>

                        <div style={styles.brand.wrap}>
                            <div style={styles.brand.logo.wrap}>
                                <div style={styles.brand.logo.placeholder}>
                                    <div style={styles.brand.logo.text}>{holderLogo(job.OganizationName)}</div>
                                </div>
                            </div>
                            <div style={styles.brand.content.wrap}>
                                <h1 style={styles.brand.content.title}>{job.Title}</h1>
                                <div style={styles.brand.content.label}>{job.OganizationName}</div>
                                <div style={styles.brand.content.label}>{job.CategoryName}</div>
                                {job.Location!="" && <div style={styles.brand.content.label}>{job.Location}</div>}
                            </div>
                        </div>

                        <hr style={{margin: 0}} />

                        <div style={styles.feature.wrap}>
                            <div style={styles.feature.title}>Job Features</div>
                            <div style={styles.feature.items}>
                                {job.Qualification!="" && <div style={styles.feature.item}>{job.Qualification}</div>}
                                {job.ExperienceLevel!="" && <div style={styles.feature.item}>{job.ExperienceLevel}</div>}
                                {job.ExperienceLength!="" && <div style={styles.feature.item}>{job.ExperienceLength} Experience</div>}
                                {job.JobType!="" && <div style={styles.feature.item}>{job.JobType}</div>}
                                {job.WorkMode!="" && <div style={styles.feature.item}>{job.WorkMode}</div>}
                                {job.Salary!="" && <div style={styles.feature.item}>{job.Salary}</div>}
                            </div>
                        </div>

                        {job.Summary!="" &&
                            <> 
                                <hr style={{margin: 0}} />
                                <div style={styles.section.wrap}>
                                    <div style={styles.section.title}>Job Summary</div>
                                    <div style={styles.section.value}>{job.Summary}</div>
                                </div>
                            </>
                        }

                        {job.Description!="" &&
                            <> 
                                <hr style={{margin: 0}} />
                                <div style={styles.section.wrap}>
                                    <div style={styles.section.title}>Job Description</div>
                                    <div style={styles.section.value}>{parse(job.Description)}</div>
                                </div>
                            </>
                        }

                    </div>

                    <div className='col-md-4'>
                        {displayApply()}
                    </div>

                </div>
            </div>
        }
        </section>
    )

    if(loading){
        return <PageLoader top={50} bottom={50} />
    }else{
        return (job) && display;
    }
}

export default JobPostDetails;